
import { Component, Vue, Prop } from "vue-property-decorator";
import WorkingHours from "../../../domain/restaurant/WorkingHours";
import WorkingHoursCard from "@/components/restaurant/workingHours/WorkingHoursCard.vue";
@Component({
  components: { WorkingHoursCard }
})
export default class WorkingHoursList extends Vue {
  @Prop({ default: [] })
  workingHoursList!: WorkingHours[];

  mounted() {
    this.workingHoursList.sort(
      WorkingHours.WorkingHoursByStartTimeAscendingComparator
    );
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }

  addWorkingHours(newWorkingHours: WorkingHours) {
    this.workingHoursList.push(newWorkingHours);
    this.workingHoursList.sort(
      WorkingHours.WorkingHoursByStartTimeAscendingComparator
    );
  }

  removeWorkingHours(toRemove: WorkingHours) {
    const indexToRemove = this.workingHoursList.indexOf(toRemove);
    if (indexToRemove > -1) {
      this.workingHoursList.splice(indexToRemove, 1);
    }
  }
}
